import React from 'react';
import { FiArrowUpCircle } from 'react-icons/fi';

import { scrollToTop } from '@/Utils/helpers';

type Props = {};

const FloatingBtn: React.FC<Props> = () => {
  return (
    <button
      className='fixed flex bottom-5  left-5 z-20 rounded-full border-none bg-white bg-opacity-80 text-gray-700 shadow'
      onClick={() => {
        scrollToTop();
      }}
    >
      <FiArrowUpCircle size={40} />
    </button>
  );
};

export default FloatingBtn;
